"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = void 0;
class Validator {
    validate(date, inletSize, serialNumber, setPressure) {
        return {
            date: this.validateDate(date),
            inletSize: this.validateInletSize(inletSize),
            serialNumber: this.validateSerialNumber(serialNumber),
            setPressure: this.validateSetPressure(setPressure),
        };
    }
    validateDate(date) {
        if (date === '') {
            return 'Please enter a date in the format YYMM.';
        }
        if (!/^[0-9]{4}$/.test(date)) {
            return 'Date should be a number in the format YYMM.';
        }
        const year = Number(date.substring(0, 2));
        if (year < 15) {
            return 'Please enter a date where the year part is 15 or later.';
        }
        return null;
    }
    validateInletSize(inletSize) {
        if (inletSize === '' || inletSize == null) {
            return 'Please choose an inlet size.';
        }
        return null;
    }
    validateSerialNumber(serialNumber) {
        if (serialNumber === '') {
            return 'Please enter a serial number.';
        }
        if (!this.isInteger(serialNumber)) {
            return 'Serial number should contain a number.';
        }
        return null;
    }
    validateSetPressure(setPressure) {
        if (setPressure === '') {
            return 'Please enter set pressure.';
        }
        if (isNaN(setPressure)) {
            return 'Set pressure should contain a number.';
        }
        return null;
    }
    isInteger(value) {
        if (isNaN(value)) {
            return false;
        }
        const x = parseFloat(value);
        return typeof x === 'number' && x % 1 === 0;
    }
}
exports.Validator = Validator;
